import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-open-icon',
  templateUrl: './lock-open-icon.component.html',
  styleUrls: ['./lock-open-icon.component.scss'],
})
export class LockOpenIconComponent {}
